<template>
  <div id="home">
    <my-header :page="'page_not_found'"></my-header>
    <div class="pd20" id="page-not-found">
      <h4>Tải mobile app</h4>
      <p>Để trải nghiệm và được hỗ trợ tốt hơn, bạn vui lòng tải ứng dụng mobile theo các nền tảng sau:</p>
      <a href="https://play.google.com/store/apps/details?id=com.f2f.app">
      <img src="/static/images/google-play-badge.png"/>
      </a>
      <a href="https://apps.apple.com/vn/app/n%C3%B4ng-tr%E1%BA%A1i-%C4%91%E1%BA%BFn-b%C3%A0n-%C4%83n/id1609911904">
      <img src="/static/images/app-store.png"/>
      </a>
    </div>
    <!-- end pd20 -->
  </div>
</template>

<script>
import MyHeader from '@/components/Layout/Header'
export default {
  name: 'DownloadApp',
  components: {
    MyHeader
  },
  data () {
    return {}
  },
  methods: {},
  mounted () {}
}
</script>



// WEBPACK FOOTER //
// src/components/Page/DownloadApps.vue